export const toBankingBsbNumber = (input: string) => {
  return input.replace(/ /g, '').replace(/(\d{3})(\d{3})/, '$1 $2')
}

export const toBankingAccountNumber = (input: string) => {
  return input.replace(/ /g, '').replace(/\d{4}(?=\d)/g, '$& ')
}
